const styles = (theme) => ({
    mainContent: {
        paddingTop: '20px',
        marginTop: '20px',
        width: '95%',
        opacity: 0.95,
        flex: '1'
    },
    toolbarSpacer: theme.mixins.toolbar,
});

export default styles;
